import React, { useContext } from 'react'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer"

export default function StepIsValid(props) {
  const { validSteps } = useContext(ConfiguratorContext)

  const can = function () {
    return props.step === null ? true : validSteps.indexOf(props.step) >= 0
  }

  return (
    <>{props.hideChildren === true && !can() ? null : React.cloneElement(props.children, { step_is_valid: can().toString() })}</>
  )
}

StepIsValid.defaultProps = {
  hideChildren: false
}
